import { AjaxPost } from "../Services/index";

export class RequestReview {
    private CartOrderNo: KnockoutObservable<string>;
    private Comment: KnockoutObservable<string>;
    private EmailTo: KnockoutObservable<string>;
    private AddressBook: KnockoutObservableArray<any> = ko.observableArray([]);

    private AddContact;
    private DataObject: any = {
        FirstName: ko.observable(null).extend({ required: true, minLength: 1, maxLength: 25 }),
        LastName: ko.observable(null).extend({ required: true, minLength: 1, maxLength: 25 }),
        Email: ko.observable(null).extend({ required: true, email: true }),
        Phone: ko.observable(null).extend({ required: true, phoneUS: true })
    };

    constructor(addressBook: KnockoutObservableArray<any>) {
        let self: RequestReview = this;

        let CartKey = "RequestNewKey";

        if (localStorage.getItem("CartSessionKey"))
            CartKey = localStorage.getItem("CartSessionKey").toString().trim();

        if (addressBook())
            self.AddressBook(addressBook())
        else {
            self.AddressBook([]);
            $.each(addressBook, function (index, item) {
                self.AddressBook().push(item);
            })
            self.AddressBook.valueHasMutated();
        }


        self.CartOrderNo = ko.observable(CartKey);
        self.Comment = ko.observable(null).extend({ required: true, minLength: 1, maxLength: 5000 });
        self.EmailTo = ko.observable(null);

        self.AddContact = function () {

            function addContactDetails(data) {
                var init: boolean = true,
                    ajaxConfig = {
                        endpoint: "/ShoppingCart/AddReviewContact",
                        payload: JSON.stringify(ko.toJS(data)),
                        cbFunction: function (res) {

                            if (init) {

                                let newContact = {
                                    FirstName: data.FirstName(),
                                    LastName: data.LastName(),
                                    EMail: data.Email(),
                                    Phone: data.Phone(),
                                    Display: data.FirstName() + " "
                                        + data.LastName() + " - "
                                        + data.Email()
                                }

                                self.AddressBook().push(newContact);
                                self.AddressBook.valueHasMutated();

                                $('#EmailTo option').filter(function (i) {
                                    return ($(this).val() === data.Email());
                                }).prop('selected', true);

                            }

                            for (var prop in self.DataObject) {


                                if (self.DataObject[prop] !== null) {
                                    if (typeof self.DataObject[prop] === "function") {
                                        self.DataObject[prop](null);
                                    }
                                }
                            }


                        }
                    };

                new AjaxPost(ajaxConfig);
            }

            $('#addContactModal').modal('show');

            $('#add-contact-submit').click(function (event) {
                let init = true;
                if (init) {
                    addContactDetails(self.DataObject);
                    // Bugfix: modal backdrop got stuck because DOM was changed when new enty was inserted, 
                    // remove backdrop before hiding modal
                    $('#addContactModal').removeClass('fade').modal('hide');

                    init = false;
                }

            });
        }
    }

}